import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ISubscription, SubscriptionsStore } from './types';
import { fetchSubscriptions } from './thunk';

const initialState: SubscriptionsStore = {
  data: null,
  loading: 'idle',
};

export const subscriptions = createSlice({
  name: 'subscriptions',
  initialState,
  reducers: {
    resetSubscriptions: (state) => {
      state.data = null;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchSubscriptions.pending, (state) => {
      state.loading = 'pending';
    });
    builder.addCase(fetchSubscriptions.fulfilled, (state, action: PayloadAction<ISubscription[]>) => {
      state.data = !!action.payload ? action.payload : null;
      state.loading = 'succeeded';
    });
  },
});

export const { resetSubscriptions } = subscriptions.actions;
export default subscriptions.reducer;
